import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import useInstallPrompt from '../hooks/useInstallPrompt';

const { FiDownload, FiX } = FiIcons;

function PwaInstallPrompt() {
  const { canInstall, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);

  if (!canInstall || dismissed) {
    return null;
  }

  return (
    <aside className="install-prompt" aria-label="Instalar aplicación">
      <button
        className="install-prompt__close"
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Cerrar sugerencia"
      >
        <SafeIcon icon={FiX} />
      </button>

      <div className="install-prompt__icon">
        <SafeIcon icon={FiDownload} />
      </div>

      <div className="install-prompt__copy">
        <strong>Instala Muchacho E’ Mandao</strong>
        <span>Accede más rápido desde tu pantalla de inicio.</span>
      </div>

      <button
        className="install-prompt__button"
        type="button"
        onClick={install}
      >
        Instalar
      </button>
    </aside>
  );
}

export default PwaInstallPrompt;